import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './AuthorizedNavigationBar.scss';

import NavigationBar from './NavigationBar';
import NavigationLink from './NavigationLink';

import {PATIENT_LINKS} from '../../sources/constants/headerLinks'

export default class PatientNavigationBar extends Component {
    static propTypes = {
        role: PropTypes.object,
        login: PropTypes.object,
        counters: PropTypes.object,
    };

    static defaultProps = {
        counters: {},
    }

    static contextTypes = {
        router: PropTypes.object,
    };

    componentDidMount() {
        const {onGetCounters} = this.props;

        onGetCounters();
    }

    render() {
        return (
            <NavigationBar className={styles.nav}>
                {PATIENT_LINKS.map(this.renderLink)}
            </NavigationBar>
        );
    }

    renderLink = ({label, path, isNeedFullAccess, showIfFullAccess, counterName}, index) => {
        const {role, login, counters} = this.props;

        if (login.user.profileNotFilledStage) {
            return null;
        }

        if (!role.isFullAccess() && isNeedFullAccess)
            return null;

        if (role.isFullAccess() && !showIfFullAccess)
            return null;

        const active = this.context.router.location.pathname === path;

        return <NavigationLink key={index}
            to={path}
            counter={counters[counterName]}
            active={active}
            label={loc(label)} />;
    };
}



// WEBPACK FOOTER //
// ./src/components/Header/PatientNavigationBar.js